// extracted by mini-css-extract-plugin
export default {"wrapper":"main_wrapper__Yfyrt","logo":"main_logo__izjku","title":"main_title__MwTgA","sub_title":"main_sub_title__xB0Mk"};